

import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { config } from "../CommonUtils/CommonURLS";

const buildSliderImageUrl = (imagePath) => {
    if (!imagePath) {
        return "";
    }

    if (/^https?:\/\//i.test(imagePath)) {
        return imagePath;
    }

    return `${config.url.FILE_DOWNLOAD_URL}${imagePath}`;
};

const WelfareBanner = () => {
    const sliderRef = useRef(null);
    const currentIndex = useRef(0);
    const intervalRef = useRef(null);
    const [slideImages, setSlideImages] = useState([]);
    const slides = [
        {
            image: "images/welfare-banner-1.webp",
        },
        {
            image: "images/banner-img1.webp",
        },
        {
            image: "images/banner-img2.webp",
        },
    ];

    async function fetchImages() {
        try {
            const response = await axios.get(config.url.STU_URL + "ov-public/getSlidingImages");
            if (response?.data?.scode === "01") {
                setSlideImages(response?.data?.data || []);
            } else {
                setSlideImages([]);
            }
        }
        catch (error) {
            console.error("Error fetching news items:", error);
        }
    }

    useEffect(() => {
        fetchImages();
    }, []);
    useEffect(() => {
        const slider = sliderRef.current;
        if (!slider || slideImages.length === 0 || slider.children.length === 0) return;

        // Clone first slide
        const firstSlide = slider.children[0].cloneNode(true);
        firstSlide.dataset.cloned = "true";
        slider.appendChild(firstSlide);

        const getSlideWidth = () => slider.children[0].offsetWidth;

        const totalSlides = slider.children.length;
        console.log("slideImages---->>", slideImages);
        const moveSlider = () => {
            currentIndex.current++;

            slider.style.transition = "0.6s";
            slider.style.transform = `translateX(-${getSlideWidth() * currentIndex.current
                }px)`;

            if (currentIndex.current === totalSlides - 1) {
                setTimeout(() => {
                    slider.style.transition = "none";
                    slider.style.transform = "translateX(0)";
                    currentIndex.current = 0;
                }, 600);
            }
        };

        intervalRef.current = setInterval(moveSlider, 3000);

        return () => {
            clearInterval(intervalRef.current);
            if (slider.lastElementChild?.dataset?.cloned === "true") {
                slider.removeChild(slider.lastElementChild);
            }
        };
    }, [slideImages]);

    const nextSlide = () => {
        const slider = sliderRef.current;
        const slideWidth = slider.children[0].offsetWidth;
        const totalSlides = slider.children.length;

        currentIndex.current++;

        slider.style.transition = "0.6s";
        slider.style.transform = `translateX(-${slideWidth * currentIndex.current
            }px)`;

        if (currentIndex.current === totalSlides - 1) {
            setTimeout(() => {
                slider.style.transition = "none";
                slider.style.transform = "translateX(0)";
                currentIndex.current = 0;
            }, 600);
        }
    };

    const prevSlide = () => {
        const slider = sliderRef.current;
        const slideWidth = slider.children[0].offsetWidth;
        const totalSlides = slider.children.length;

        if (currentIndex.current <= 0) {
            currentIndex.current = totalSlides - 1;

            slider.style.transition = "none";
            slider.style.transform = `translateX(-${slideWidth * currentIndex.current
                }px)`;
        }

        setTimeout(() => {
            currentIndex.current--;

            slider.style.transition = "0.6s";
            slider.style.transform = `translateX(-${slideWidth * currentIndex.current
                }px)`;
        }, 20);
    };

    return (
        <div className="walfare-banner d-block d-md-flex justify-content-between">
            <div className="banner-left">
                <h2>Uplifting<br />
                    Communities,<br />
                    Building Futures</h2>

                <img
                    src="images/boxs-bg.png"
                    className="img-fluid boxes-bg"
                    alt=""
                />

                <img
                    src="images/CBN.webp"
                    className="img-fluid cm"
                    alt=""
                />
            </div>

            <div className="kwdc-slider-wrapper">
                <div className="kwdc-slider" ref={sliderRef}>
                    {slideImages?.map((slide, index) => (
                        <div className="kwdc-slide" key={index}>
                            <div className="main-image">
                                <img src={buildSliderImageUrl(slide.image)} alt={slide.imageDescription || `slide-${index}`} />
                            </div>

                            {/*
              <div className="side-images">
                <img src="" alt="" />
                <img src="" alt="" />
              </div>
              */}
                        </div>
                    ))}
                </div>

                <div className="nav-buttons">
                    <button className="prev" onClick={prevSlide}>
                        <img
                            src="images/banner-left-arrow.png"
                            alt=""
                        />
                    </button>

                    <button className="next" onClick={nextSlide}>
                        <img
                            src="images/banner-right-arrow.png"
                            alt=""
                        />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WelfareBanner;